<ion-content class="ion-padding reset-container">
  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size="12" size-md="10" size-lg="4">
        <ng-container *ngIf="isCodeValid; else invalidCode">
          <div class="reset-card">
            <div class="logo-container">
              <img
                src="../../assets/images/logo-sollo-black.svg"
                alt="Sollo Logo"
                draggable="false"
              />
            </div>
            <h2 class="title">
              {{ 'RESET_PASSWORD.resetPasswordLabel' | translate }}
            </h2>

            <sol-input
              [(ngModel)]="password"
              (ngModelChange)="validatePasswordRealtime()"
              [inputType]="inputType.PASS"
              [clearInput]="true"
              label="{{ 'RESET_PASSWORD.newPassword' | translate }}"
              [fullWidth]="true"
              [showLine]="'start'"
              [editMode]="true"
            >
            </sol-input>

            <sol-input
              [(ngModel)]="confirmPassword"
              (ngModelChange)="validatePasswordRealtime()"
              [inputType]="inputType.PASS"
              [clearInput]="true"
              label="{{ 'RESET_PASSWORD.confirmNewPassword' | translate }}"
              [fullWidth]="true"
              [showLine]="'start'"
              [editMode]="true"
            >
            </sol-input>

            <ng-container *ngIf="password || confirmPassword">
              <ion-chip
                [class.valid]="passwordValidations.length"
                [class.invalid]="!passwordValidations.length"
              >
                <span>
                  <ion-icon name="checkmark-outline"></ion-icon>
                  {{ 'SETTINGS.PASSWORD_VALIDATION.char' | translate }}
                </span>
              </ion-chip>

              <ion-chip
                [class.valid]="passwordValidations.uppercase"
                [class.invalid]="!passwordValidations.uppercase"
              >
                <span>
                  <ion-icon name="checkmark-outline"></ion-icon>
                  {{ 'SETTINGS.PASSWORD_VALIDATION.upperCase' | translate }}
                </span>
              </ion-chip>

              <ion-chip
                [class.valid]="passwordValidations.lowercase"
                [class.invalid]="!passwordValidations.lowercase"
              >
                <span>
                  <ion-icon name="checkmark-outline"></ion-icon>
                  {{ 'SETTINGS.PASSWORD_VALIDATION.lowerCase' | translate }}
                </span>
              </ion-chip>

              <ion-chip
                [class.valid]="passwordValidations.numbers"
                [class.invalid]="!passwordValidations.numbers"
              >
                <span>
                  <ion-icon name="checkmark-outline"></ion-icon>
                  {{ 'SETTINGS.PASSWORD_VALIDATION.numbers' | translate }}
                </span>
              </ion-chip>

              <ion-chip
                [class.valid]="passwordValidations.specialChar"
                [class.invalid]="!passwordValidations.specialChar"
              >
                <span>
                  <ion-icon name="checkmark-outline"></ion-icon>
                  {{ 'SETTINGS.PASSWORD_VALIDATION.specialChar' | translate }}
                </span>
              </ion-chip>

              <ion-chip
                [class.valid]="passwordValidations.match"
                [class.invalid]="!passwordValidations.match"
              >
                <span>
                  <ion-icon name="checkmark-outline"></ion-icon>
                  {{ 'SETTINGS.PASSWORD_VALIDATION.passwordMatch' | translate }}
                </span>
              </ion-chip>
            </ng-container>

            <ion-button expand="block" color="primary" (click)="onSubmit()">
              {{ 'RESET_PASSWORD.changePassword' | translate }}
            </ion-button>
          </div>
        </ng-container>

        <ng-template #invalidCode>
          <ion-card class="invalid-card">
            <ion-card-header>
              <ion-card-title>Oops!</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              {{ 'COMMON.ALERTS.errorCode' | translate }}
            </ion-card-content>
          </ion-card>
        </ng-template>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
